/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.onboarding.painid

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import org.koin.compose.viewmodel.koinViewModel
import studio.oddpods.cauce.core.base.ui.EventsEffect
import studio.oddpods.cauce.core.ui.scaffold.KptScaffold

@Composable
fun PainIdScreen(
    onNavigateNext: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: PainIdViewModel = koinViewModel(),
) {
    val state by viewModel.stateFlow.collectAsStateWithLifecycle()

    EventsEffect(eventFlow = viewModel.eventFlow) { event ->
        when (event) {
            PainIdEvent.NavigateNext -> onNavigateNext()
        }
    }

    KptScaffold(
        showNavigationIcon = false,
        title = "¿Qué es lo más pesado?",
        modifier = modifier,
    ) {
        Column(
            modifier = Modifier.fillMaxSize().padding(24.dp),
        ) {
            Text(
                text = "Elegí las que más te molestan. Esto nos ayuda a personalizar tu experiencia.",
                style = MaterialTheme.typography.bodyMedium,
            )
            Spacer(Modifier.height(24.dp))
            Column(modifier = Modifier.weight(1f).verticalScroll(rememberScrollState())) {
                PainOption.entries.forEach { option ->
                    val selected = option in state.selected
                    PainOptionCard(
                        label = option.label(),
                        selected = selected,
                        onClick = { viewModel.trySendAction(PainIdAction.Toggle(option)) },
                    )
                    Spacer(Modifier.height(12.dp))
                }
            }
            Button(
                onClick = { viewModel.trySendAction(PainIdAction.ContinueClick) },
                enabled = state.selected.isNotEmpty(),
                modifier = Modifier.fillMaxWidth(),
            ) { Text("Siguiente") }
        }
    }
}

@Composable
private fun PainOptionCard(label: String, selected: Boolean, onClick: () -> Unit) {
    val container =
        if (selected) {
            MaterialTheme.colorScheme.primaryContainer
        } else {
            MaterialTheme.colorScheme.surfaceVariant
        }
    ElevatedCard(
        onClick = onClick,
        colors = CardDefaults.elevatedCardColors(containerColor = container),
        modifier = Modifier.fillMaxWidth(),
    ) {
        Text(
            text = label,
            modifier = Modifier.padding(16.dp),
            style = MaterialTheme.typography.bodyLarge,
        )
    }
}

private fun PainOption.label(): String = when (this) {
    PainOption.COBROS -> "Cobrar y hacer seguimiento de pagos"
    PainOption.AFIP -> "Facturación AFIP / ARCA"
    PainOption.DEUDA_TOTAL -> "Saber cuánto me deben en total"
    PainOption.RECORDATORIOS -> "Recordarle a pacientes que paguen"
    PainOption.REGISTRO -> "Llevar registro de sesiones"
}
